import React from "react";
import "./MobileMenu.css";
import { Link } from "react-router-dom";
import ScrollToTopLink from "../../../Utils/ScrollToTop";
const MobileMenu = ({ isOpen, onClose }) => {
  if (!isOpen) return null;

  const handleOverlayClick = () => {
    onClose();
  };

  const handleMenuClick = (e) => {
    e.stopPropagation();
  };

  return (
    <div className="mobile-menu-overlay" onClick={handleOverlayClick}>
      <div className="mobile-menu-glass" onClick={handleMenuClick}>
      <ScrollToTopLink to="/">Home</ScrollToTopLink>
      <ScrollToTopLink to="/solutions">Solutions</ScrollToTopLink>
          <ScrollToTopLink to="/about">About Us</ScrollToTopLink>
          <ScrollToTopLink to="/media">Media & Partners</ScrollToTopLink>
          <ScrollToTopLink to="/contact">Contact Us</ScrollToTopLink>
      </div>
      <button className="close-button" onClick={onClose}>×</button>
    </div>
  );
};

export default MobileMenu;
